import React from 'react'
import AppLayout from './AppLayout';
import PageContainer from '@/components/template/PageContainer';

const Test = () => {
  return (
    <PageContainer>
      page test
    </PageContainer>
  )
}

Test.layout = (page: React.ReactNode) => <AppLayout children={page} />;
export default Test;
